<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <div class="main">
      <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
        @onChange="onSearchItemChange">
        <template #start>
          <!-- 复合日期搜索框 -->
          <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
            @onChange="onComSelectSearchChange">
          </CompositeFormDate>
        </template>
        <!-- 导出按钮 -->
        <template #end>
          <el-form-item class="endBtn">
            <el-button type="primary" icon="el-icon-download" @click="Export(`承运车辆利润表-车辆运单列表`)">导出</el-button>
          </el-form-item>
        </template>
        <!-- 表头设置控件 -->
        <template #right>
          <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
            @onChange="onTableSelect" />
        </template>
      </SearchField>

      <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
        :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
        @onSizeChange="onSizeChange" />
    </div>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
// 这里引入运单基础文件是为了统一删除方法，但是会引起获取路由参数之前请求数据，故取消引入，复制删除方法到本文件
// import mixin from "@/pages/orderManage/nonContractOrder/own/mixin";

let fromPath = null

export default {
  // mixins: [tableMixin, mixin],
  mixins: [tableMixin],
  data() {
    return {
      breadcrumb: [
        { name: "财务管理", path: '/finance/carrierProfit' },
        { name: "承运利润表", path: '/finance/carrierProfit' },
        { name: "承运车辆利润表", path: '/finance/carrierProfitCarList' },
        { name: "车辆运单列表" },
      ],
      baseUrl: 'order',
      formInline: {
        order_type: 3,
        ischeck: 2,
        isstatus: 4,
      },
      searchDateOptions: [
        { ...this.ctrls.ZhuangHuoRiQi, },
        { ...this.ctrls.XieHuoRiQi, },
      ],
      formCtrl: [
        {
          label: "客户名称",
          keyName: "shname",
          placeholder: "请填写客户名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "pcustomname", label: "承运公司", minwidth: 120 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 110 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { ...this.ctrls.XieHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuiton", label: "亏吨重量", align: 'right', className: 'pr30', width: 110 },
        { keyName: "caton", label: "计算量", align: 'right', className: 'pr30', width: 110 },
        { keyName: "ceton", label: "客担亏吨", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dtonprice", label: "亏吨单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "cprice", label: "运费单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "dprice", label: "承运单价", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "运费金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "承运金额", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "additional_fees", label: "附加费用", minwidth: 120 },
        { keyName: "compen", label: "运单补差", minwidth: 120 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "nickname", label: "派单人", minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id, ischeck }) => {
            let path = `/finance/carrierProfitOrderDetail`
            let mode = 'edit'
            if (ischeck == 2) {
              path = '/finance/carrierProfitOrderHireDetail'
            }
            this.$router.push({
              path,
              query: {
                id,
                mode,
              }
            });
          },
        },
        {
          ...this.delBtn,
          cb: this.delete,
        },
      ],
      getTotalProperty: [
        'caton',
        'inton',
        'unton',
        'kuiton',
        'kuitotal',
        'infreight',
        'freight',
        'ys_freight',
        'additional_fees',
        'compen',
        'yf_freight',
      ],
      baseParams: [
        'order_type',
        'ischeck',
        'isstatus',
        'license',
      ],
    };
  },
  methods: {
    delete({ order_num }) {
      console.log('order_num', order_num)
      this.$prompt('删除原因', '确认删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(({ value }) => {
        this.delReq(order_num, value);
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    },
    delReq(order_num, del_desc) {
      this.loading = true
      let url = `order/delorder`;
      const params = {
        userid: this.user.id,
        order_num,
        del_desc
      }
      this.post(url, params, ({
        msg
      }) => {
        this.loading = false
        if (msg == 'success') {
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '删除失败，请稍后重试！'
        });
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    fromPath = from.fullPath
    // console.log(fromPath)
    next()
  },
  mounted() {
    this.setQueryParams();
    console.log('formInline', { ...this.formInline })
    this.$nextTick(this.getList);
    if (fromPath) {
      this.breadcrumb[2].path = fromPath
    }
    // console.log(this.breadcrumb)
  },
};
</script>
